import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState({ type: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus({ type: "loading", message: "Submitting…" });
    try {
      const res = await axios.post(`${API}/newsletter`, {
        email: email.trim(),
        name: name.trim() || null,
      });
      setStatus({
        type: res.data.already_subscribed ? "info" : "success",
        message: res.data.message,
      });
      setEmail("");
      setName("");
    } catch (err) {
      const detail =
        err?.response?.data?.detail?.[0]?.msg ||
        err?.response?.data?.detail ||
        "Something went wrong. Please try again.";
      setStatus({ type: "error", message: String(detail) });
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative bg-[#0A0A0A] text-[#F5F0E8] border-t border-[#C41E1E]/40"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <span className="overline">
              Stay Connected · Follow the Journey
            </span>
            <h2 className="mt-4 font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Walk with us
              <br />
              <span className="italic text-[#C41E1E]">to the opening.</span>
            </h2>
            <p className="mt-6 max-w-xl pl-mute text-base md:text-lg leading-relaxed">
              A small list. Invitations to the opening night, public
              conversations, and an occasional note from Abdou Karim and the
              curatorial team. Write when there is something worth saying.
            </p>
          </div>

          <div className="lg:col-span-5 pl-sharp">
            <form
              onSubmit={submit}
              data-testid="newsletter-form"
              className="space-y-4"
            >
              <div>
                <label
                  htmlFor="nl-name"
                  className="block text-[10px] uppercase tracking-[0.3em] mb-2 pl-mute"
                >
                  Your Name (optional)
                </label>
                <input
                  id="nl-name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  data-testid="newsletter-name-input"
                  className="w-full bg-transparent border border-[#F5F0E8]/30 text-[#F5F0E8] placeholder:text-[#F5F0E8]/40 px-4 py-4 text-base focus:outline-none focus:border-[#C41E1E]"
                  placeholder="Aisha, Abdou, Lydia…"
                />
              </div>
              <div>
                <label
                  htmlFor="nl-email"
                  className="block text-[10px] uppercase tracking-[0.3em] mb-2 pl-mute"
                >
                  Your Email *
                </label>
                <input
                  id="nl-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="newsletter-email-input"
                  className="w-full bg-transparent border border-[#F5F0E8]/60 text-[#F5F0E8] placeholder:text-[#F5F0E8]/40 px-4 py-4 text-base focus:outline-none focus:border-[#C41E1E]"
                  placeholder="you@example.com"
                />
              </div>
              <button
                type="submit"
                data-testid="newsletter-submit-btn"
                disabled={status.type === "loading"}
                className="pl-cta pl-cta-primary pl-cta-block disabled:opacity-60"
              >
                {status.type === "loading" ? "Sending…" : "Stay Connected →"}
              </button>
              {status.message && (
                <p
                  data-testid="newsletter-status"
                  className="text-sm mt-3 text-[#F5F0E8]"
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
